import script from "./PickReleaseTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./PickReleaseTab.vue?vue&type=script&setup=true&lang=ts"

import "./PickReleaseTab.vue?vue&type=style&index=0&id=7e909c0b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e909c0b"]])

export default __exports__